const cashierProcessing = "/cashier-processing";
const CASHIER_PROCESSING_WINDOW = "CASHIER_PROCESSING_WINDOW";
const isCashierProcessingPath = window.location.pathname.includes(cashierProcessing);
export {
  CASHIER_PROCESSING_WINDOW,
  cashierProcessing,
  isCashierProcessingPath
};
